import { useEffect, useState } from 'react';

function ProductCard({ image, title, price }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [image]);

  return (
    <div className="product-card">
      <div className="product-card-image-wrapper" style={{ position: 'relative' }}>
        {!loaded && <div className="image-placeholder"></div>}
        <img
          src={image}
          alt={title}
          className={`product-card-image ${loaded ? 'loaded' : ''}`}
          loading="lazy"
          onLoad={() => setLoaded(true)}
        />
      </div>
      <h3 className="product-card-title">{title}</h3>
      <p className="product-card-price">{price}</p>
    </div>
  );
}

export default ProductCard;
